// Datastart 两条固定纯图片线路；不要复用为文字/视觉理解 provider。
export const DATASTART_IMAGE_MODELS = Object.freeze([
  { id: 'datastart_sunburst', provider: 'DATASTART_SUNBURST', model: 'gpt-image-2.5-sunburst-sp', label: 'Image-2.5_线路5 · DataStart Sunburst' },
  { id: 'datastart_flare', provider: 'DATASTART_FLARE', model: 'gpt-image-2.5-flare-sp', label: 'Image-2.5_线路5 · DataStart Flare' },
]);

export const DATASTART_IMAGE_ASPECT_OPTIONS = Object.freeze([
  { value: '1:1', label: '1:1 · 1024×1024', size: '1024x1024' },
  { value: '3:2', label: '3:2 · 1536×1024', size: '1536x1024' },
  { value: '2:3', label: '2:3 · 1024×1536', size: '1024x1536' },
]);

export const DATASTART_IMAGE_QUALITY_OPTIONS = Object.freeze([
  { value: '1K', label: '原生尺寸 · 1024/1536px' },
]);
export const DATASTART_GENERATION_QUALITY_OPTIONS = Object.freeze([
  { value: 'auto', label: '自动 · Auto' },
  { value: 'high', label: '高 · High' },
  { value: 'medium', label: '中 · Medium' },
  { value: 'low', label: '低 · Low' },
]);
export const DATASTART_EDIT_QUALITY_OPTIONS = Object.freeze(
  DATASTART_GENERATION_QUALITY_OPTIONS.filter(({ value }) => value !== 'auto'),
);
export const DATASTART_TEXT_UNAVAILABLE_MESSAGE = 'DataStart 暂未提供文字模型，后续补充';

export const normalizeDatastartImageQuality = (quality, isEdit = false) => {
  const value = String(quality || '').trim().toLowerCase();
  const options = isEdit ? DATASTART_EDIT_QUALITY_OPTIONS : DATASTART_GENERATION_QUALITY_OPTIONS;
  return options.some(option => option.value === value) ? value : isEdit ? 'medium' : 'auto';
};
export const DATASTART_IMAGE_MAX_REFERENCES = 1;
export const DATASTART_IMAGE_CAPABILITY_HINT = '原生尺寸：方图 1024×1024，横图 1536×1024，竖图 1024×1536；当前按文档接入单张参考图，支持蒙版编辑，不提供 2K/4K。';

export const getDatastartImageModel = (provider) => {
  const id = String(provider || '').trim().toLowerCase();
  return DATASTART_IMAGE_MODELS.find((item) => item.id === id || item.model === id);
};
export const isDatastartImageProvider = (provider) => Boolean(getDatastartImageModel(provider));

// 老画布/工坊保留原方向，新线路只按已公布的三种实际尺寸提交。
export const normalizeDatastartImageAspectRatio = (ratio, provider) => {
  if (!isDatastartImageProvider(provider)) return ratio;
  const [width, height] = String(ratio || '1:1').split(/[:x×]/i).map(Number);
  return width > height ? '3:2' : height > width ? '2:3' : '1:1';
};

export const getCompatibleImageAspectOptions = (options, provider) => (
  isDatastartImageProvider(provider) ? DATASTART_IMAGE_ASPECT_OPTIONS : options
);

export const assertDatastartImageInputLimit = (imagesOrCount, provider) => {
  if (!isDatastartImageProvider(provider)) return;
  const count = Array.isArray(imagesOrCount) ? imagesOrCount.filter(Boolean).length : Number(imagesOrCount);
  if (count > DATASTART_IMAGE_MAX_REFERENCES) {
    throw new Error(`Datastart 当前最多支持 ${DATASTART_IMAGE_MAX_REFERENCES} 张参考图，已选择 ${count} 张；请手动减少参考图或选择其他模型，现有图片不会被清空。`);
  }
};

export const normalizeDatastartImageTaskPayload = (payload, provider, { validateReferences = true, normalizeAspectRatio = true } = {}) => {
  const model = getDatastartImageModel(provider);
  if (!model) return payload;
  const input = payload || {};
  const references = [
    input.baseImage, input.baseImageUrl, input.refImageUrl, input.sourceImage, input.sourceImageUrl,
    input.sketchBase64, input.previousBoardImageUrl,
    input.image, input.referenceImage,
    ...(Array.isArray(input.referenceImages) ? input.referenceImages : []),
    ...(Array.isArray(input.reference_images) ? input.reference_images : []),
    ...(Array.isArray(input.images) ? input.images : []),
    ...(Array.isArray(input.characterRefs) ? input.characterRefs : []),
    ...(Array.isArray(input.sceneRefs) ? input.sceneRefs : []),
    ...(Array.isArray(input.propRefs) ? input.propRefs : []),
  ].flat().map((item) => typeof item === 'string' ? item : item?.url || item?.base64 || item?.imageUrl).filter(Boolean);
  if (validateReferences) {
    assertDatastartImageInputLimit([...new Set(references)], provider);
  }
  const isEdit = references.length > 0 || Boolean(input.maskImage || input.mask);
  const requestedQuality = input.quality ?? input.imageQuality;
  const includeQuality = isEdit || String(requestedQuality ?? '').trim() !== '';
  return {
    ...input,
    imageModel: model.model,
    imageQualityTier: '1K',
    ...(includeQuality ? { quality: normalizeDatastartImageQuality(requestedQuality, isEdit) } : {}),
    ...(normalizeAspectRatio && input.aspectRatio ? { aspectRatio: normalizeDatastartImageAspectRatio(input.aspectRatio, provider) } : {}),
  };
};
